import { PMSs } from 'main/hotelBrandsAndChains'

export const userEmailsRestartPMS = [
  'sinan@swaypay.io',
  'sinan@directful.com',
  'ercan.atbas@swaypay.io',
  'ercan.atbas@directful.com',
  'sevket@swaypay.io',
  'sevket@directful.com',
  'sevket01@sevder.com',
  'huseyin.kartal@directful.com'
]

export const userEmailsCanMarkInviteAsPaid = [
  'sinan@swaypay.io',
  'sinan@directful.com',
  'sevket01@sevder.com',
  'sevket@swaypay.io',
  'sevket@directful.com',
  'gizem.erdeniz@directful.com'
]

export const userEmailsCanToggleUserDefaultOperaReports = [
  'sinan@swaypay.io',
  'sinan@directful.com',
  'sevket01@sevder.com',
  'sevket@swaypay.io',
  'sevket@directful.com'
]

export const PMSsWithSyncLoginSupport = [
  PMSs.choiceadvantage,
  PMSs.skytouch,
  PMSs.webrezpro,
  PMSs.visualmatrix,
  PMSs.roomkey,
  PMSs.resnexus,
  PMSs.ohip,
  PMSs.jonaschorum,
  PMSs.marriottgxp,
  PMSs.clock,
  PMSs.maestro,
  PMSs.infor
]

export const PMSsCanSwitchToOhip = [PMSs.opera, PMSs.operadefault]
